import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

const Login = () => {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/dashboard" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(username.trim(), password);
      if (u.must_change_password) {
        navigate("/change-password");
      } else {
        navigate("/dashboard");
      }
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex" style={{ background: "var(--color-bg)" }}>
      {/* Brand panel */}
      <div className="hidden md:flex md:w-1/2 flex-col justify-between p-12 text-white" style={{ background: "#0F2044" }}>
        <div>
          <div className="text-2xl font-bold tracking-tight">
            Ray Intl <span className="text-slate-400">|</span> Radish Tech
          </div>
          <div className="text-xs uppercase tracking-widest text-slate-400 mt-2">
            Duty Reconciliation Hub
          </div>
        </div>
        <div className="space-y-3 max-w-md">
          <h1 className="text-4xl font-bold leading-tight">
            Reconcile every dollar of duty.
          </h1>
          <p className="text-slate-300">
            Estimated vs. actual. Line by line. Shipment by shipment. Full audit trail
            from quote to clearance.
          </p>
        </div>
        <div className="text-xs text-slate-500 uppercase tracking-widest">
          Internal use only · v1.0
        </div>
      </div>

      <div className="flex-1 flex items-center justify-center p-6">
        <form
          onSubmit={submit}
          data-testid="login-form"
          className="w-full max-w-sm bg-white rounded-lg p-8 shadow-sm"
          style={{ border: "1px solid var(--color-border)" }}
        >
          <h2 className="text-xl font-bold text-[#0F2044] mb-1">Sign in</h2>
          <p className="text-sm text-gray-500 mb-6">
            Use your assigned account to continue.
          </p>

          <label className="block text-xs font-semibold uppercase tracking-wider text-gray-500 mb-1">
            Username
          </label>
          <input
            data-testid="login-username"
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            className="w-full mb-4 px-3 py-2 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-[#0F2044]/30"
            style={{ border: "1px solid var(--color-border)" }}
            required
            autoFocus
          />

          <label className="block text-xs font-semibold uppercase tracking-wider text-gray-500 mb-1">
            Password
          </label>
          <input
            data-testid="login-password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full mb-6 px-3 py-2 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-[#0F2044]/30"
            style={{ border: "1px solid var(--color-border)" }}
            required
          />

          <button
            data-testid="login-submit"
            type="submit"
            disabled={loading}
            className="w-full bg-[#0F2044] text-white py-2.5 rounded-md text-sm font-semibold hover:bg-[#1a2f5c] transition-colors disabled:opacity-60"
          >
            {loading ? "Signing in..." : "Sign in"}
          </button>

          <div className="text-xs text-gray-400 mt-6 leading-relaxed">
            Default accounts: <span className="font-mono">admin</span>,{" "}
            <span className="font-mono">finance1</span>,{" "}
            <span className="font-mono">viewer1</span>
            <br />
            Initial passwords distributed separately. You will be required to set a new password on first login.
          </div>
        </form>
      </div>
    </div>
  );
};

export default Login;
